import React, { useEffect, useRef, useState } from 'react';
import { format as dfFormat, format } from 'date-fns';
import YmdPicker from '../../../components/picker/YmdPicker';
import 'react-datepicker/dist/react-datepicker.css';
import Input from '../../../components/inputs/Input';
import { CostPostRequest } from '../../../types/cost/CostPostRequest';
import { CategoryArray } from '../../../types/cost/CostGetResponse';
import { focusNextInput } from '../../../utils/focusNextInput';
import SubmitAndCancelButton from '../../../components/button/SubmitAndCancelButton';

interface AddCostRowProps {
  item: CostPostRequest;
  categories: CategoryArray[];
  onChange: (key: keyof CostPostRequest, value: any) => void;
  onAddSubmitButtonClick: () => void;
  onSubmitCancelButtonClick: () => void;
}

const AddCostRow: React.FC<AddCostRowProps> = ({
  item,
  categories,
  onChange,
  onAddSubmitButtonClick,
  onSubmitCancelButtonClick,
}) => {
  const inputsRef = useRef<
    (HTMLInputElement | HTMLSelectElement | HTMLButtonElement)[]
  >([]);

  // 最初の input に自動フォーカス
  useEffect(() => {
    if (inputsRef.current[0]) {
      inputsRef.current[0].focus();
    }
  }, []);

  return (
    <>
      <td>
        <select
          value={item.costCategoryId}
          onChange={(e) => onChange('costCategoryId', Number(e.target.value))}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el))
              inputsRef.current.push(el);
          }}
          onKeyDown={(e: any) => focusNextInput(e, inputsRef as any, 0)}
          className="form-select"
        >
          <option value={0} disabled>
            選択してください
          </option>
          {categories.map((c) => (
            <option key={c.id} value={c.id}>
              {c.category}
            </option>
          ))}
        </select>
      </td>
      <td>
        <Input
          value={item.detail}
          onChange={(e) => onChange('detail', e.target.value)}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef as any, 1)}
        />
      </td>
      <td>
        <YmdPicker
          selectedDate={item.date ? new Date(item.date) : null}
          setSelectedDate={(date) =>
            onChange('date', date ? format(date, 'yyyy-MM-dd') : '')
          }
          placeholder="年/月/日"
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef as any, 2)}
        />
      </td>
      <td>
        <Input
          value={item.price === 0 ? '' : String(item.price)}
          onChange={(e) => onChange('price', e.target.value)}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef as any, 3)}
        />
      </td>
      <td className="text-center">
        <SubmitAndCancelButton
          onSubmit={() => onAddSubmitButtonClick()}
          onCancel={() => onSubmitCancelButtonClick()}
          submitButtonRef={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          cancelButtonRef={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onSubmitKeyDown={(e) => focusNextInput(e, inputsRef as any, 4)}
          onCancelKeyDown={(e) => focusNextInput(e, inputsRef as any, 5)}
        />
      </td>
    </>
  );
};

export default AddCostRow;
